import { use } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { HandshakeOutlined } from '@mui/icons-material';
import { Switch, SxProps, Theme, Typography } from '@mui/material';
import Constants from 'style/constants';

import CareConnectSettingsProviderContext from 'features/care-connect-settings/contexts/care-connect-settings-provider-context';
import styles from 'features/care-connect-settings/views/components/call-plan-toggle-row/call-plan-toggle-row.module.scss';

const CallPlanToggleRow = (): React.JSX.Element => {
  const { t } = useTranslation('careConnectSettings');

  const { selectedOrganisationUnit, callPlanDetails } = use(CareConnectSettingsProviderContext);

  const { callPlanForm, isEditing } = callPlanDetails;

  const isCallPlanEnabled = useWatch({ control: callPlanForm.control, name: 'isCallPlanEnabled' });

  const textSx: SxProps<Theme> = {
    color: Constants.Colors.onSurfaceVariant,
    opacity: isCallPlanEnabled ? Constants.Opacity.full : Constants.Opacity.disabled,
  };

  const iconSx: SxProps<Theme> = {
    color: isCallPlanEnabled ? Constants.Colors.primary : Constants.Colors.onSurfaceVariant,
    opacity: isCallPlanEnabled ? Constants.Opacity.full : Constants.Opacity.disabled,
    transform: 'scaleX(-1)',
  };

  if (!selectedOrganisationUnit) {
    return <></>;
  }

  return (
    <div className={styles.toggleRow}>
      <div className={styles.toggleContent}>
        <Controller
          name="isCallPlanEnabled"
          control={callPlanForm.control}
          render={({ field }) => (
            <Switch
              checked={field.value ?? false}
              onChange={(_, checked) => field.onChange(checked)}
              onBlur={field.onBlur}
              disabled={!isEditing}
            />
          )}
        />
        <HandshakeOutlined sx={iconSx} />
        <Typography variant="h5" sx={textSx}>
          {t('details.callPlan')}
        </Typography>
      </div>
      <Typography variant="body2" sx={textSx}>
        {t(isCallPlanEnabled ? 'details.active' : 'details.disabled')}
      </Typography>
    </div>
  );
};

export default CallPlanToggleRow;
